import * as React from 'react'
import { createPortal } from 'react-dom'

import CommunityFeedbackSection from './community-feedback-section'

import type { NonFsdsGeneralV1FeedbackDialog } from '@/types/non-fsds-general-v1.type'

const useBrowserLayoutEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect

/** Places legacy Hero feedback after Course Journey while older published snapshots are migrated. */
export default function CommunityFeedbackPlacement(props: NonFsdsGeneralV1FeedbackDialog) {
  const sourceRef = React.useRef<HTMLSpanElement>(null)
  const [target, setTarget] = React.useState<HTMLElement | null>(null)

  useBrowserLayoutEffect(() => {
    const ownerDocument = sourceRef.current?.ownerDocument
    setTarget(ownerDocument?.querySelector<HTMLElement>('[data-gv1-community-feedback-slot]') ?? null)
  }, [])

  const section = <CommunityFeedbackSection {...props} />

  return (
    <>
      <span ref={sourceRef} hidden aria-hidden="true" />
      {target ? createPortal(section, target) : section}
    </>
  )
}
